export default __webpack_public_path__ + "static/media/kitchen3-afterA-1024w.e76c2d3b.webp";